import { eq } from 'tio-ui/utilities';
import { get } from '@ember/object';
import { hash } from '@ember/helper';
import { PhCurrencyCircleDollar } from 'ember-phosphor-icons';
import Popover from 'tio-ui/components/popover';
import { t } from 'ember-intl';
import type { TOC } from '@ember/component/template-only';

export interface ReimbursementTagSignature {
  Args: {
    size?: 'sm' | 'md' | 'lg';
    disablePopover?: boolean;
  };
  Element: HTMLDivElement;
}

const ReimbursementPopoverTag: TOC<ReimbursementTagSignature> = <template>
  <div
    class="tio-flex-extra-tight items-center tio-fg-secondary
      {{if (eq @size 'sm') 'text-sm' (if (eq @size 'lg') 'text-lg' 'text-base')}}"
    ...attributes
  >
    <PhCurrencyCircleDollar
      @size={{get (hash sm=16 md=20 lg=24) (if @size @size "md")}}
      class="tio-fg-secondary flex-none"
    />

    {{#if @disablePopover}}
      <span class="tio-fg-secondary">
        {{t "tuition_assistance.limits_summary.reimbursement"}}
      </span>
    {{else}}
      <Popover @triggerMode="hover">
        <:trigger as |pop|>
          <button type="button" {{pop.register}} {{pop.hoverHandlers}} class="self-start">
            <span class="underline underline-offset-4 decoration-1 tio-fg-secondary">
              {{t "tuition_assistance.limits_summary.reimbursement"}}
            </span>
          </button>
        </:trigger>
        <:body>
          <div class="p-2 flex flex-col gap-y-2 tio-fg-secondary text-base/7">
            <span class="font-semibold">{{t
                "tuition_assistance.limits_summary.reimbursement"
              }}</span>
            <p class="leading-6">{{t "tuition_assistance.limits_summary.reimbursement_body"}}</p>
          </div>
        </:body>
      </Popover>
    {{/if}}
  </div>
</template>;

export default ReimbursementPopoverTag;
